import { Route } from "./data/types";
import { configService } from './services';
import {
  BidSupport,
  Contact,
  ContentTemplate,
  DealRegistration,
  Enable,
  Assets,
  Episode,
  Home,
  Incentive,
  IncentiveLeaderboard,
  LeaderboardV2,
  Learn,
  Profile,
  Reward,
  RewardInfo,
  Error404
} from "./pages";
import { Splash } from "./components/Splash";
import { CampaignTemplate } from "./modules";
import { MyDeals } from "./modules/OpportunityManagement/MyDeals.component";
import { SpinTheWheel } from "./components/SpinTheWheel";
import { EditSend, EmailerHome } from "./modules/Emailer";
import { LayoutType } from "./services/config.service.types";
import CampaignFilter from "./pages/CampaignFilter";

import Temp_Campaign from "./components/Temp_Campaign";
import Temp_Article from "./components/Temp_Article";




const RicohRoutes: Route[] = [
  // {
  //   to: '/',
  //   component: CampaignFilter,
  //   name: 'CampaignFilter',
  //   requiresAuth: false,
  // },
  // {
  //   to: '/campaigns',
  //   component: CampaignFilter,
  //   name: 'CampaignFilter',
  //   requiresAuth: true,
  // },
  {
    to: '/prize/:campaignId',
    component: CampaignTemplate,
    name: 'CampaignHome',
    requiresAuth: true,
  },
  {
    to: '/win/:identifier',
    component: ContentTemplate,
    name: 'ContentHome',
    requiresAuth: true,
  },
  {
    to: '/profile',
    component: Profile,
    name: 'Profile',
    requiresAuth: true,
  },
  {
    to: '/Temp_Campaign',
    component: Temp_Campaign,
    name: 'temp',
    requiresAuth: false,
  },
  {
    to: '*',
    component: Error404,
    name: '404 Error',
    requiresAuth: false,
  },
]

const ZebraRoutes: Route[] = [
  {
    to: '/',
    component: Home,
    name: 'Home',
    requiresAuth: true,
  },
  {
    to: '/article/:identifier',
    component: ContentTemplate,
    name: 'Article',
    requiresAuth: false,
  }, {
    to: '/campaigns',
    component: CampaignFilter,
    name: 'CampaignFilter',
    requiresAuth: true,
  }, {
    to: '/campaign/:campaignId',
    component: CampaignTemplate,
    name: 'CampaignHome',
    requiresAuth: true,
  },
  {
    to: '/Assets',
    component: Assets,
    name: 'Assets',
    requiresAuth: true,
  },
  {
    to: '/Assets/:filePath',
    component: Assets,
    name: 'Assets',
    requiresAuth: true,
  },
  {
    to: '/Temp_Campaign',
    component: Temp_Campaign,
    name: 'temp',
    requiresAuth: false,
  },
  {
    to: '/Temp_Article',
    component: Temp_Article,
    name: 'temp',
    requiresAuth: false,
  },
  // {
  //   to: '/profile',
  //   component: Profile,
  //   name: 'Profile',
  //   requiresAuth: true,
  // },
]

let defaultRoutes = [
  {
    to: '/',
    component: Home,
    name: 'Home',
    requiresAuth: false,
  },
  {
    to: '/learn',
    component: Learn,
    name: 'Learn',
    requiresAuth: true,
  },
  {
    to: '/learn/:episodeId',
    component: Episode,
    name: 'Episode',
    requiresAuth: true,
  },
  {
    to: '/Assets',
    component: Assets,
    name: 'Assets',
    requiresAuth: true,
  },
  {
    to: '/Assets/:filePath',
    component: Assets,
    name: 'Assets',
    requiresAuth: true,
  },
  {
    to: '/enable',
    component: Enable,
    name: 'Enable',
    requiresAuth: true,
  },
  {
    to: '/reward',
    component: Reward,
    name: 'Reward',
    requiresAuth: true,
  },
  {
    to: '/reward/:campaignId',
    component: Incentive,
    name: 'Incentive',
    requiresAuth: true,
  },
  {
    to: '/reward/:campaignId/leaderboard',
    component: IncentiveLeaderboard,
    name: 'Incentive Leaderboard',
    requiresAuth: true,
  },
  {
    to: '/reward/:campaignId/registerdeal',
    component: DealRegistration,
    name: 'Register Deal',
    requiresAuth: true,
  },
  {
    to: '/reward/info',
    component: RewardInfo,
    name: 'Virtual Reward Information',
    requiresAuth: true,
  },
  {
    to: '/bidsupport',
    component: BidSupport,
    name: 'Bid Support',
    requiresAuth: true,
  },
  {
    to: '/profile',
    component: Profile,
    name: 'Profile',
    requiresAuth: true,
  },
  {
    to: '/contact',
    component: Contact,
    name: 'Contact us',
    requiresAuth: true,
  },
  {
    to: '/article/:identifier',
    component: ContentTemplate,
    name: 'Article',
    requiresAuth: false,
  },
  {
    to: '/incentive',
    component: Incentive,
    name: 'Incentive',
    requiresAuth: true,
    nestedRoutes: [
      {
        to: ':campaignId',
        component: CampaignTemplate,
        name: 'CampaignHome',
        requiresAuth: true,
      },
      {
        to: ':campaignId/article/:identifier',
        component: ContentTemplate,
        name: 'Article',
        requiresAuth: true,
      },
      {
        to: ':campaignId/mydeals',
        component: MyDeals,
        name: 'MyDeals',
        requiresAuth: true,
      },
      {
        to: ':campaignId/dealreg',
        component: DealRegistration,
        name: 'DealReg',
        requiresAuth: true,
      },
      {
        to: ':campaignId/dealreg/:opportunityId',
        component: DealRegistration,
        name: 'DealReg',
        requiresAuth: true,
      },
      {
        to: ':campaignId/salestools',
        component: Enable,
        name: 'Enable',
        requiresAuth: true,
      },
      {
        to: ':campaignId/leaderboard',
        component: LeaderboardV2,
        name: 'Leaderboard',
        requiresAuth: true,
      },
      {
        to: ':campaignId/learn',
        component: Learn,
        name: 'Training',
        requiresAuth: true,
      },
      {
        to: ':campaignId/learn/:episodeId',
        component: Episode,
        name: 'Episode',
        requiresAuth: true,
      },
      {
        to: ':campaignId/learn/:episodeId/:rewardId/instantwin',
        component: SpinTheWheel,
        name: 'SpinTheWheel',
        requiresAuth: true,
      }
    ]
  }
]

let legacyRoutes: Route[] = [
  {
    to: '/',
    component: Splash,
    name: 'Home',
    requiresAuth: false,
  },
  {
    to: '/incentive',
    component: Incentive,
    name: 'Incentive',
    requiresAuth: true,
    nestedRoutes: [
      {
        to: ':campaignId',
        component: CampaignTemplate,
        name: 'CampaignHome',
        requiresAuth: true,
      },
      {
        to: ':campaignId/article/:identifier',
        component: ContentTemplate,
        name: 'Article',
        requiresAuth: true,
      },
      {
        to: ':campaignId/mydeals',
        component: MyDeals,
        name: 'MyDeals',
        requiresAuth: true,
      },
      {
        to: ':campaignId/dealreg',
        component: DealRegistration,
        name: 'DealReg',
        requiresAuth: true,
      },
      {
        to: ':campaignId/dealreg/:opportunityId',
        component: DealRegistration,
        name: 'DealReg',
        requiresAuth: true,
      },
      {
        to: ':campaignId/salestools',
        component: Enable,
        name: 'Enable',
        requiresAuth: true,
      },
      {
        to: ':campaignId/leaderboard',
        component: LeaderboardV2,
        name: 'Leaderboard',
        requiresAuth: true,
      },
      {
        to: ':campaignId/learn',
        component: Learn,
        name: 'Training',
        requiresAuth: true,
      },
      {
        to: ':campaignId/learn/:episodeId',
        component: Episode,
        name: 'Episode',
        requiresAuth: true,
      },
      {
        to: ':campaignId/learn/:episodeId/:rewardId/instantwin',
        component: SpinTheWheel,
        name: 'SpinTheWheel',
        requiresAuth: true,
      }
    ]
  }
]

let emailerRoutes: Route[] = [
  {
    to: '/',
    component: EmailerHome,
    name: 'Home',
    requiresAuth: true,
  },
  {
    to: '/send/:templateId',
    component: EditSend,
    name: 'EditSend',
    requiresAuth: true,
  }
]

function routerSelector(layoutType: LayoutType) {
  switch (layoutType) {
    case LayoutType.Legacy:
      return legacyRoutes;
    case LayoutType.Emailer:
      return emailerRoutes;
    case LayoutType.ZebraTechnologies:
      return ZebraRoutes;
    case LayoutType.RicohRewards:
      return RicohRoutes;
    case LayoutType.Canon:
    default:
      return defaultRoutes;
  }
}

export const routes: Route[] = routerSelector(configService.current().layoutType);

